const EXPO_COMPANY_PROFILE_RE =
  /^\/(?:expos|global-events-exhibitions)\/([^/]+)\/company\/([^/]+)\/?$/;
const EXPO_DIRECTORY_PATH_RE = /^\/(?:expos|global-events-exhibitions)\/[^/]+\/?$/;

export function buildExpoCompanyProfilePath(expoSlug: string, companyId: string): string {
  const slug = expoSlug.trim();
  const id = companyId.trim();
  return `/expos/${encodeURIComponent(slug)}/company/${encodeURIComponent(id)}`;
}

/** Guest directory stays on the public expo URL so the landing shell does not remount. */
export function buildGuestExpoCompanyProfilePath(expoSlug: string, companyId: string): string {
  const slug = expoSlug.trim();
  const id = companyId.trim();
  return `/global-events-exhibitions/${encodeURIComponent(slug)}/company/${encodeURIComponent(id)}`;
}

/** Expo directory list (`/expos/:slug` or the public guest directory), not a company profile. */
export function isExpoDirectoryReturnPath(returnTo: string): boolean {
  const pathname = returnTo.trim().split("?")[0] || "";
  return EXPO_DIRECTORY_PATH_RE.test(pathname);
}

/** Slug from `/expos/:slug/company/:id`. Ignores the legacy `/expos/company/:id` path. */
export function expoSlugFromCompanyProfilePath(pathname?: string | null): string | null {
  if (!pathname?.trim()) return null;
  const path = pathname.trim().split("?")[0] || "";
  const match = EXPO_COMPANY_PROFILE_RE.exec(path);
  if (!match?.[1]) return null;
  const slug = decodeURIComponent(match[1]).trim();
  if (!slug || slug.toLowerCase() === "company") return null;
  return slug;
}

export function expoSlugFromProfileSearch(search?: string | null): string | null {
  if (!search?.trim()) return null;
  const qs = search.trim().startsWith("?") ? search.trim().slice(1) : search.trim();
  return new URLSearchParams(qs).get("fromExpo")?.trim() || null;
}

/** Legacy `?fromExpo=` links resolve to the dedicated expo company route. */
export function expoCompanyPathFromLegacySearch(companyId: string, search?: string | null): string | null {
  const slug = expoSlugFromProfileSearch(search);
  if (!slug || !companyId.trim()) return null;
  return buildExpoCompanyProfilePath(slug, companyId);
}

/** Header CTA on a live expo exhibitor company profile (opens ExpoCompanyReachoutModal). */
export const EXPO_COMPANY_REACH_OUT_CTA = "Reach-out";
